/** @file Editor grid settings and the effective tile size (isoAngle 30 derives the tile height). */
import { isoTileHeight } from '@pose2d/core/direction/isoTileHeight';

/** The document's `view.grid` fields this package reads (snap and footprint stay with the caller). */
export interface GridView {
  mode: 'off' | 'square' | 'iso';
  tileW: number;
  tileH: number;
  isoAngle: 'ratio' | 30;
}

/** [tileW, tileH] in world px; an iso grid with isoAngle 30 takes tileH from core isoTileHeight (spec 5.10). */
export function gridTileSize(grid: GridView): [number, number] {
  if (grid.mode === 'iso' && grid.isoAngle === 30) return [grid.tileW, isoTileHeight(grid.tileW)];
  return [grid.tileW, grid.tileH];
}
